export default function () {
  const widgetName = 'fairgroundsMultiScheduleFeature';
  const widgetOpts = fairgroundsMultiScheduleFeatureOpts;
  const breakpoint = 800;

  initializeWidget(widgetName, widgetOpts, breakpoint);
}

function initializeWidget(widgetName, widgetOpts, breakpoint) {
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: true,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: true,
    allEventsLinkText: 'view all events',
    link: 'all',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: (data) => handleMultiFeatureLoaded(data, widgetName, breakpoint),
  });
}

function handleMultiFeatureLoaded(data, widgetName, breakpoint) {
  if (data.length === 0) {
    removeWidget(widgetName);
    return;
  }

  const windowSize = $(window).width();
  const featureContainer = $('#fairgroundsMultiScheduleFeature');

  data.forEach((event, index) => {
    const eventElement = $(`#${widgetName} .featureItem`).eq(index);
    const dateLayout = buildEventDate(event.Date);
    const eventInfoLayout = buildEventInfoLayout(event.Name, event.ImageURL, event.URL);

    updateEventElement(
      eventElement,
      eventInfoLayout,
      dateLayout,
      event.URL,
      windowSize,
      breakpoint,
    );
  });

  updateAllEventsButton(data.length, featureContainer);
  $(`#${widgetName}`).prepend('<h2 class="events-title" >Upcoming Events at the Fairgrounds</h2>');
}

function removeWidget(widgetName) {
  $(`#${widgetName}`).remove();
  $('body').addClass('noEvents');
}

function updateEventElement(element, infoLayout, dateLayout, url, windowSize, breakpoint) {
  element.empty().append(infoLayout);

  if (windowSize > breakpoint || !url) {
    element.removeAttr('href').addClass(url ? '' : 'void');
  } else {
    element.attr('href', url);
  }

  element.append(dateLayout);
}

function updateAllEventsButton(eventsQuantity, container) {
  const allEventsButton = $('.all-events-btn').addClass('button').appendTo(container);
  allEventsButton.wrap('<div class="btn-container"></div>');
}

function buildEventDate(date) {
  const fixedDate = date.split('-');
  const [startMonth, startDay, endMonth, endDay] = parseEventDate(fixedDate);

  return buildEventDateLayout(startMonth, startDay, endMonth, endDay);
}

function parseEventDate(fixedDate) {
  switch (fixedDate.length) {
    case 1:
      return [
        formatDate(fixedDate, 0, 0, 0).substring(0, 3),
        formatDate(fixedDate, 0, 0, 1),
        null,
        null,
      ];
    case 2:
      return [
        formatDate(fixedDate, 0, 0, 0),
        formatDate(fixedDate, 0, 0, 1),
        formatDate(fixedDate, 1, 0, 0).substring(0, 3),
        formatDate(fixedDate, 1, 0, 1),
      ];
    default:
      return [null, null, null, null];
  }
}

function buildEventInfoLayout(title, image, url) {
  const imageUrl = image || `${FULLCLIENTTHEMEPATH}images/no-image-available.jpg`;
  const overlay = url
    ? `<div class="overlay">
         <a class="button" href="${url}">More</a>
       </div>`
    : '';

  return `
    <div class="img-container">
      ${overlay}
      <img src="${imageUrl}" alt="${title}" class="event-image">
    </div>
    <span class="event-name">${title}</span>`;
}

function buildEventDateLayout(startMonth, startDay, endMonth = null, endDay = null) {
  if (!endMonth || !endDay) {
    return `
      <div class="event-date">
        <span class="month">${startMonth}.</span>
        <span class="day">${startDay}</span>
      </div>`;
  }

  if (startMonth === endMonth) {
    return `
      <div class="event-date double-date">
        <span class="month">${startMonth}.</span>
        <span class="day">${startDay}<span class="separator"></span>${endDay}</span>
      </div>`;
  }

  return `
    <div class="event-date date-range">
      <div class="combo-date">
        <span class="month">${startMonth}.</span>
        <span class="day">${startDay}</span>
      </div>
      <span class="separator-month"></span>
      <div class="combo-date">
        <span class="month">${endMonth}.</span>
        <span class="day">${endDay}</span>
      </div>
    </div>`;
}

function formatDate(date, slot1, slot2, slot3) {
  return date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
}
